import { useCallback, useMemo } from 'react';
import { RoutePath, allRoutes, safeRoutes } from '../pages';
import { useAccount } from './useAccount';
import { useModalState } from './useModalState';
import { useRouteState } from './useRouteState';

export const useRouter = () => {
  const open = useModalState((s) => s.open);
  const setOpen = useModalState((s) => s.setOpen);
  const setRoute = useRouteState((state) => state.setRoute);
  const { isConnected } = useAccount();

  const navigate = useCallback(
    (route: RoutePath, state?: object) => {
      let validRoute = route;
      if (!allRoutes.includes(route)) {
        validRoute = isConnected ? RoutePath.WalletInfo : RoutePath.Signup;
      }

      if (isConnected) {
        if (!safeRoutes.connected.includes(route)) {
          validRoute = RoutePath.WalletInfo;
        }
      } else {
        if (!safeRoutes.disconnected.includes(route)) {
          validRoute = RoutePath.Signup;
        }
      }
      setOpen(true);
      setRoute({ path: validRoute, state });
    },
    [isConnected, setOpen, setRoute]
  );

  const close = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return useMemo(() => ({ navigate, close, isOpen: open }), [navigate, close, open]);
};
